var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInputEyeClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24405 5.41076C5.42817 4.68963 6.88678 4.09613 8.49996 4.09613C10.1131 4.09613 11.5718 4.68963 12.7559 5.41076C13.9465 6.13583 14.92 7.02647 15.5742 7.70425L15.6281 7.76006C16.0219 8.16707 16.3461 8.50211 16.3461 8.99998C16.3461 9.49784 16.0219 9.83288 15.6281 10.2399L15.5742 10.2957C14.92 10.9735 13.9465 11.8641 12.7559 12.5892C11.5718 13.3103 10.1131 13.9038 8.49996 13.9038C6.88678 13.9038 5.42817 13.3103 4.24405 12.5892C3.05346 11.8641 2.07994 10.9735 1.42576 10.2957L1.37181 10.2399C0.977988 9.83288 0.653809 9.49784 0.653809 8.99998C0.653809 8.50211 0.977988 8.16707 1.37181 7.76005L1.42576 7.70425C2.07994 7.02647 3.05346 6.13583 4.24405 5.41076Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputEyeClose);
export default __webpack_public_path__ + "static/media/input-eye-close.933d2975cea2120afb41dcfca9e420d5.svg";
export { ForwardRef as ReactComponent };